// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import {
      CAvatar,
      CButton,
      CCard,
      CCardBody,
      CCardSubtitle,
      CCardTitle,
      CCol,
      CDropdown,
      CDropdownItem,
      CDropdownMenu,
      CDropdownToggle,
      CProgress,
      CRow,
      // CCardHeader,
      // CTable,
      // CTableBody,
      // CTableDataCell,
      // CTableHead,
      // CTableHeaderCell,
      // CTableRow,
      // CWidgetStatsA,
      // CForm,
      // CFormLabel,
      // CFormInput,
      // CFormText,
      // CFormCheck,
      // CModal,
      // CModalHeader,
      // CModalBody,
} from '@coreui/react-pro'

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// import Table from "examples/Tables/Table";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import '@coreui/coreui/dist/css/coreui.min.css'
import '@coreui/coreui-pro/dist/css/coreui.min.css'
import { FormControl, FormLabel } from '@mui/material';
import { useState, useEffect } from "react";
import { UsersService } from "services/UsersAuth";
import toast, { Toaster } from 'react-hot-toast';
import RichEditor from "layouts/trainingProgramClass/Editor";





function TermsAndConditions() {

      const [TermsAndConditions, setTermsAndConditions] = useState("");


      useEffect(() => {
            getTermsDetail()
      }, [])

      const getTermsDetail = async () => {
            const privacyData = await UsersService.viewTermsAndCondition();
            if (privacyData.status === 200) {
                  setTermsAndConditions(privacyData?.data?.data?.desciption)
            }
      }

      const postSettingDetail = async (e) => {
            e.preventDefault()
            const updateTerms = await UsersService.updateTermsAndCondition(TermsAndConditions);
            if (updateTerms.status === 200) {
                  getTermsDetail()
                  toast.success('Successfully Created!', {
                        position: "top-right"
                  })
            }

      }


      const onTextChange = (value, editor) => {
            setTermsAndConditions(value);
      }




      return (
            <DashboardLayout>
                  <DashboardNavbar />
                  <Toaster />
                  <CRow>
                        <CCol xs={12}>
                              <CCard className="mb-4">

                                    <CCardBody>
                                          <form>
                                                <FormLabel>Terms And Conditions</FormLabel>
                                                <RichEditor
                                                      editorDefaultText={TermsAndConditions}
                                                      handleUpdate={onTextChange}
                                                ></RichEditor>

                                                <br />
                                                <br />
                                                <Button
                                                      variant="contained"
                                                      color="primary"
                                                      type="submit"
                                                      onClick={(e) => { postSettingDetail(e) }}
                                                >
                                                      Submit
                                                </Button>
                                          </form>
                                    </CCardBody>
                              </CCard>
                        </CCol>
                  </CRow>
                  <Footer />
            </DashboardLayout>
      );
}

export default TermsAndConditions;

